import IJitRepository from '../domain/IJitRepository';
import jitRepository from '../infrastructure/repositories/JitRepository';

class DeleteTransitsService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._jitRepository
      .deleteJitTransitsById({ queryParams })
      .then((res) => res);
  }
}

export default new DeleteTransitsService({ repository: jitRepository });

export { DeleteTransitsService };
